/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/h4': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.052 18.043H8.96v-5.37H3.556v5.37h-2.1V5.957h2.1v5.03H8.96v-5.03h2.092v12.086zM21.041 13.735h1.503v1.619H21.04v2.689h-2.017v-2.69h-5.22l-.059-1.228 5.213-8.168h2.084v7.778zm-5.18 0h3.163V8.688l-.149.266-3.013 4.78z" _fill="currentColor"/>'
  }
})
